// package: achievementmanager
// file: achievement-manager.proto

var achievement_manager_pb = require("./achievement-manager_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var AchievementManager = (function () {
  function AchievementManager() {}
  AchievementManager.serviceName = "achievementmanager.AchievementManager";
  return AchievementManager;
}());

AchievementManager.GenerateCertificate = {
  methodName: "GenerateCertificate",
  service: AchievementManager,
  requestStream: false,
  responseStream: false,
  requestType: achievement_manager_pb.GenerateCertificateReq,
  responseType: achievement_manager_pb.GenerateCertificateReply
};

AchievementManager.GetCertificate = {
  methodName: "GetCertificate",
  service: AchievementManager,
  requestStream: false,
  responseStream: false,
  requestType: achievement_manager_pb.GetCertificateReq,
  responseType: achievement_manager_pb.GetCertificateReply
};

AchievementManager.ListMyCertificates = {
  methodName: "ListMyCertificates",
  service: AchievementManager,
  requestStream: false,
  responseStream: false,
  requestType: achievement_manager_pb.ListMyCertificatesReq,
  responseType: achievement_manager_pb.ListMyCertificatesReply
};

AchievementManager.DeleteCertificate = {
  methodName: "DeleteCertificate",
  service: AchievementManager,
  requestStream: false,
  responseStream: false,
  requestType: achievement_manager_pb.DeleteCertificateReq,
  responseType: achievement_manager_pb.DeleteCertificateReply
};

AchievementManager.GetSharedCertificate = {
  methodName: "GetSharedCertificate",
  service: AchievementManager,
  requestStream: false,
  responseStream: false,
  requestType: achievement_manager_pb.GetSharedCertificateReq,
  responseType: achievement_manager_pb.GetSharedCertificateReply
};

exports.AchievementManager = AchievementManager;

function AchievementManagerClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

AchievementManagerClient.prototype.generateCertificate = function generateCertificate(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AchievementManager.GenerateCertificate, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AchievementManagerClient.prototype.getCertificate = function getCertificate(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AchievementManager.GetCertificate, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AchievementManagerClient.prototype.listMyCertificates = function listMyCertificates(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AchievementManager.ListMyCertificates, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AchievementManagerClient.prototype.deleteCertificate = function deleteCertificate(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AchievementManager.DeleteCertificate, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AchievementManagerClient.prototype.getSharedCertificate = function getSharedCertificate(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AchievementManager.GetSharedCertificate, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.AchievementManagerClient = AchievementManagerClient;

var Internal = (function () {
  function Internal() {}
  Internal.serviceName = "achievementmanager.Internal";
  return Internal;
}());

Internal.IntGetCertificate = {
  methodName: "IntGetCertificate",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: achievement_manager_pb.IntGetCertificateReq,
  responseType: achievement_manager_pb.IntGetCertificateReply
};

Internal.IntRevokeCertificates = {
  methodName: "IntRevokeCertificates",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: achievement_manager_pb.IntRevokeCertificatesReq,
  responseType: achievement_manager_pb.IntRevokeCertificatesReply
};

Internal.IntDeleteUserCertificates = {
  methodName: "IntDeleteUserCertificates",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: achievement_manager_pb.IntDeleteUserCertificatesReq,
  responseType: achievement_manager_pb.IntDeleteUserCertificatesReply
};

exports.Internal = Internal;

function InternalClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

InternalClient.prototype.intGetCertificate = function intGetCertificate(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntGetCertificate, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intRevokeCertificates = function intRevokeCertificates(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntRevokeCertificates, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intDeleteUserCertificates = function intDeleteUserCertificates(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntDeleteUserCertificates, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.InternalClient = InternalClient;

